const HYBRID_MODE = "hybrid_ecommerce"

const SCHEDULED_DELIVERY_LISTING_MODES = new Set([
  "scheduled_ecommerce",
  "hybrid_ecommerce",
  "promise_window",
])

export const brandShowsScheduledDeliveryDateInOrders = (brand = null) => {
  const mode = String(brand?.deliveryProfile?.mode || "").trim()
  if (!mode) {
    return false
  }
  return SCHEDULED_DELIVERY_LISTING_MODES.has(mode)
}

export const brandSupportsFastMovingItems = (scopeCards = [], brandId = null) => {
  const cards = Array.isArray(scopeCards) ? scopeCards : []
  const normalizedBrandId = String(brandId || "").trim()

  if (normalizedBrandId) {
    const card = cards.find(
      entry => String(entry.brandId) === normalizedBrandId
    )
    return card?.mode === HYBRID_MODE
  }

  return cards.some(entry => entry.mode === HYBRID_MODE)
}
